import React, { useEffect } from "react";
import { Button, message } from "antd";
import { WaitPaySearchBox } from "./SearchBox";
import { WaitPayDataTable } from "./DataTable";
import { CollectDrawer } from "./PayDrawer";
import { YhBox } from "@/components/YhBox";
import { useWaitCollectModel } from "./waitPayModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { CollectBatchDrawer } from "./PayBatchDrawer";

export const WaitCashPay = () => {
  const {
    selectedData,
    selectedRowKeys,
    setCollectDrawerVisible,
    loadData,
    setCollectBatchDrawerVisible,
  } = useWaitCollectModel();

  useEffect(() => {
    loadData({ pageNum: 1 }).then()
  }, [])

  // useEffect(() => {
  //   let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
  //   const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
  //   setSelectedData(selectedData)
  // }, [selectedRowKeys]);

  const onPay = () => {
    if (selectedRowKeys && selectedRowKeys.length > 0) {
      setCollectDrawerVisible(true);
    } else {
      message.error("请选择收款账单!");
    }
  }

  const onPayBatch = () => {
    if (selectedRowKeys && selectedRowKeys.length > 0) {
      setCollectBatchDrawerVisible(true);
    } else {
      message.error("请选择收款账单!");
    }
  }

  const action = (
    <div>
      {/* <Button
          className="mr-5"
          type="link"
          shape="round"
          onClick={() => { }}
        >
          导出
        </Button> */}
      <YhAuth resCode={ResourceAuthEnum.CASH_PAY_WILL_PAY}>
        <Button
          className="mr-5"
          type="link"
          shape="round"
          disabled={selectedData.length !== 1}
          onClick={onPay}
        >
          付款
        </Button>
      </YhAuth>
      <YhAuth resCode={ResourceAuthEnum.CASH_PAY_WILL_PAY_BATCH}>
        <Button
          className="mr-5"
          type="link"
          shape="round"
          disabled={selectedData.length < 2}
          onClick={onPayBatch}
        >
          批量付款
        </Button>
      </YhAuth>
    </div>
  );

  return (
    <>
      <WaitPaySearchBox />
      <YhBox title={"待付列表"} action={action}>
        <WaitPayDataTable />
      </YhBox>
      <CollectDrawer />
      <CollectBatchDrawer />
    </>
  )
}

